/**
 * Turn content into a file and start the download for the user
 * Borrowed from http://bit.ly/2oKP2ll
 */
export const downloadFile = (filename: string, content: string) => {
  const element = document.createElement("a");
  const file = new File([content], filename, { type: "application/json" });
  const href = URL.createObjectURL(file);

  element.setAttribute("href", href);
  element.setAttribute("download", filename);
  element.style.display = "none";

  if (document.body !== null) {
    document.body.append(element);
  }

  element.click();

  if (document.body !== null) {
    element.remove();
  }
};
